import { CalendarOutlined } from "@ant-design/icons";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import PropTypes from "prop-types";

const CustomDatePicker = ({
    placeholder,
    showTime,
    minDate,
    maxDate,
    value,
    onChange,
    style = {},
    disableFuture,
    disablePast,
    range,
    disabled,
    insideModal,
    showNowButton = false,
    error,
}) => (
    <DatePicker
        suffixIcon={<CalendarOutlined />}
        showNow={showNowButton}
        format={`MM/DD/YYYY ${showTime ? "hh:mm A" : ""}`}
        status={(error && "error") || ""}
        placement={!insideModal ? "bottomLeft" : undefined}
        getPopupContainer={(triggerNode) =>
            triggerNode.parentElement?.parentElement?.parentElement || document.body
        }
        inputReadOnly
        style={{
            pointerEvents: disabled ? "none" : undefined,
            width: "100%",
            borderRadius: "6px",
            color: disabled ? "#AAAAAA" : undefined,
            ...style,
        }}
        showTime={
            showTime
                ? {
                      use12Hours: true,
                      format: "h:mm A",
                      minuteStep: 30,
                  }
                : false
        }
        placeholder={placeholder || "Select Date"}
        minDate={
            range?.start
                ? dayjs(range.start)
                : minDate
                  ? dayjs(minDate)
                  : disablePast
                    ? dayjs(Date.now())
                    : undefined
        }
        maxDate={
            range?.end ? dayjs(range.end) : maxDate ? dayjs(maxDate) : disableFuture ? dayjs(Date.now()) : undefined
        }
        value={value ? dayjs(value) : undefined}
        onChange={(_, dateString) => {
            onChange(dateString);
        }}
        allowClear={false}
        disabled={disabled}
        onOk={() => {}}
    />
);

CustomDatePicker.propTypes = {
    placeholder: PropTypes.string,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    value: PropTypes.instanceOf(Date),
    onChange: PropTypes.func.isRequired,
    showTime: PropTypes.bool,
    style: PropTypes.object,
    disableFuture: PropTypes.bool,
    disablePast: PropTypes.bool,
    range: PropTypes.shape({
        start: PropTypes.instanceOf(Date),
        end: PropTypes.instanceOf(Date),
    }),
    disabled: PropTypes.bool,
    insideModal: PropTypes.bool,
    showNowButton: PropTypes.bool,
    error: PropTypes.string,
};

CustomDatePicker.defaultProps = {
    placeholder: undefined,
    minDate: undefined,
    maxDate: undefined,
    value: undefined,
    showTime: false,
    style: {},
    disableFuture: false,
    disablePast: false,
    range: undefined,
    disabled: false,
    insideModal: false,
    showNowButton: false,
    error: undefined,
};

export default CustomDatePicker;
